import styled, { CSSObject } from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const mobileStyles: CSSObject = {
  fontSize: '32px',
  lineHeight: '40px'
};

const desktopStyles: CSSObject = {
  fontSize: '36px',
  lineHeight: '45px'
};

const StyledPriceContent = styled.span(
  {
    display: 'block',
    [media('xs')]: mobileStyles,
    [media('lg')]: desktopStyles
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue,
    fontWeight: theme.typography.fontWeightSemiBold
  })
);

export default StyledPriceContent;
